<template>
  <vs-popup fullscreen :active.sync="isSidebarActiveLocal" title="Detayları" v-esc="escape">
    <div class="con-example-prompt content-wrapper" id="temelWrap" v-if="detailData != null">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12" id="" vs-justify="space-between">
          <vs-col vs-type="flex" vs-w="12" class="pl-5 py-5">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="space-between">
                <span class="text-primary bold h4">
                  {{ detailData.userWantDto.branchName }} ({{ detailData.userWantDto.userName }})
                  ({{ formatDate(detailData.userWantDto.created) }})
                </span>
                <div v-if="$isCenterBranch()" class="control-container">
                  <vs-select class="status-select" label="Durum" v-model="currentStatus" @change="handleStatusChange">
                    <vs-select-item v-for="(status, index) in statusOptions" :key="index" :value="status.value"
                      :text="status.text" />
                  </vs-select>
                  <vs-button color="primary" class="history-button" @click="showStatusLogs">
                    İşlem Geçmişi Görüntüle
                  </vs-button>
                </div>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-1">
                <span class="h5 w-full">
                  {{ detailData.userWantDto.content }}
                </span>
              </vs-row>

              <!-- Add Files Section -->
              <vs-row v-if="detailData.userWantDto.files && detailData.userWantDto.files.length > 0" vs-type="flex"
                vs-w="12" class="mt-4">
                <vs-col vs-type="flex" vs-w="12">
                  <div class="files-container">
                    <h4 class="text-primary mb-2">Eklenen Dosyalar:</h4>
                    <div class="files-list">
                      <div v-for="(file, index) in detailData.userWantDto.files" :key="index" class="file-item">
                        <div class="file-icon">
                          <vs-icon icon="insert_drive_file" size="large"></vs-icon>
                        </div>
                        <div class="file-details">
                          <a @click="downloadFile(file)" target="_blank" class="file-link">
                            {{ getFileName(file) }}
                          </a>
                        </div>
                        <div class="file-actions">
                          <vs-button type="flat" icon-pack="feather" icon="icon-download" size="small"
                            @click="downloadFile(file)"></vs-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
              <!-- End Files Section -->

            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
      <vs-divider color="primary" class="px-5 m-0 my-1" />
      <vs-row id="billContentEntry" vs-type="flex" vs-w="12" vs-justify="space-between"
        v-for="(entry, index) in detailData.entries" :key="index">
        <vs-row :vs-justify="entry.userId != $currentUser.id ? 'flex-start' : 'flex-end'">
          <vs-col type="flex" vs-justify="flex-end" vs-align="center" vs-w="6" style="margin-right: 1rem;">
            <vs-card class="content-card">
              <div slot="header">
                <span>
                  {{ '(' + entry.userName + ')' }}
                </span>
              </div>
              <div class="content-wrapper">
                <span>{{ entry.content }}</span>
              </div>
              <div slot="footer">
                <vs-row vs-justify="flex-end">
                  <span style="font-size: 0.7rem;">{{ (entry.createdText) }}</span>
                </vs-row>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-row>
    </div>
    <div class="fixed-input">
      <form data-vv-scope="form-1" @submit.prevent>
        <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6" vs-justify="center">
          <vs-col vs-type="flex" vs-w="11" class="pl-5 ">
            <div class="w-full">
              <vs-textarea label="Yorum" name="Yorum" v-validate="'required|min:2'" size="large" v-model="comment"
                @keydown.enter.exact.prevent="createComment" @keydown.shift.enter.prevent="newLine" />
            </div>
          </vs-col>

        </vs-row>
        <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6" vs-justify="center">
          <vs-col vs-type="flex" vs-w="11" class="pl-5">
            <vs-button :disabled="!isCommentValid" size="small" type="gradient" @click="createComment">Gönder
            </vs-button>
          </vs-col>
        </vs-row>
      </form>
    </div>
    <vs-popup :active.sync="statusLogsPopupActive" title="Statü Logları">
      <vs-list>
        <vs-list-item v-for="(log, index) in statusLogs" :key="index" class="status-log-item">
          <div>
            <vs-row>
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                <span class="log-text">{{ log.text }}</span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
                <span class="log-user">{{ log.userName }}</span>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
                <span class="log-date">{{ log.date }}</span>
              </vs-col>
            </vs-row>
          </div>
        </vs-list-item>
      </vs-list>
    </vs-popup>
  </vs-popup>

  <!-- Statü Logları Popup -->

</template>


<script>
import { getDetail, addComment, getLogs, changeStatus } from "@/api/UserWant";
import { uploadFile } from "@/api/UserWant";
import companyInfo from '../../../model/constants/companyInfo';
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      logo: companyInfo.logo,
      detailData: {},
      comment: '',
      moment: require('moment-timezone'),
      statusLogs: [],
      statusLogsPopupActive: false,
      currentStatus: 0,
      statusOptions: [
        { value: 0, text: 'İletildi' },
        { value: 1, text: 'Süreç Başlatıldı' },
        { value: 2, text: 'Tamamlandı' }
      ],
      isInitialLoad: true
    }
  },
  computed: {
    isCommentValid() {
      return this.comment !== null && this.comment.trim() !== ''
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.$validator.reset();
          this.initValues();
        }
      }
    }
  },
  watch: {
    isSidebarActive: function (val) {
      if (!val) return;
      console.log(this.data);
      getDetail(this.data.id).then((res) => {
        if (res && res.status == 200) {
          console.log(res.data);
          this.detailData = res.data;
          this.isInitialLoad = true; // Set flag before changing status
          this.currentStatus = this.detailData.userWantDto.status;
          this.$nextTick(() => {
            this.isInitialLoad = false; // Reset flag after component updates
          });
          setTimeout(() => {
            const element = document.getElementById("temelWrap");
            element.scrollTop = element.scrollHeight;
          }, 200); // 200 milisaniye (0.2 saniye) bekle
          this.comment = ''
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Hata : " + res.status,
          });
        }
      })
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    escape() {
      this.isSidebarActiveLocal = false;
    },
    newLine(e) {
      this.comment += '\n';
    },
    createComment: async function () {
      let newComment = {
        userWantId: this.data.id,
        content: this.comment,
      }

      let checker;
      checker = await this.$validator.validateAll("form-1");
      if (checker) {
        try {
          const res = await addComment(newComment);

          if (res && res.status == 200) {
            this.detailData.entries.push(res.data);
            setTimeout(() => {
              const element = document.getElementById("temelWrap");
              element.scrollTop = element.scrollHeight;
            }, 200);

            // Reset form
            this.comment = '';

            this.$vs.notify({
              color: 'success',
              title: 'Başarılı !',
              text: 'Yorumunuz Eklendi '
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata !',
              text: 'Yorum Ekleme Başarısız ! '
            });
          }
        } catch (error) {
          let errorMessage = 'Yorum Ekleme Başarısız!';
          if (error.response && error.response.data && error.response.data.Errors && error.response.data.Errors.length > 0) {
            errorMessage = error.response.data.Errors[0].Message;
          }
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: errorMessage
          });
        }
      }
    },
    showStatusLogs() {
      getLogs(this.data.id).then((res) => {
        if (res && res.status == 200) {
          this.statusLogs = res.data;
          this.statusLogsPopupActive = true;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Statü logları yüklenirken bir hata oluştu.'
          });
        }
      }).catch((error) => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Statü logları yüklenirken bir hata oluştu.'
        });
      });
    },
    handleStatusChange(value) {
      // Skip API call if this is just initial data loading
      if (this.isInitialLoad) return;

      const statusData = {
        userWantId: this.data.id,
        status: value
      };

      changeStatus(statusData).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: 'success',
            title: 'Başarılı!',
            text: 'Durum başarıyla güncellendi'
          });

          // Refresh data to show updated status
          getDetail(this.data.id).then((res) => {
            if (res && res.status == 200) {
              this.detailData = res.data;
            }
          });
        } else {
          let errorMessage = 'Durum güncellenemedi';
          if (res && res.response && res.response.data && res.response.data.Errors && res.response.data.Errors.length > 0 && res.response.data.Errors[0].Message) {
            errorMessage = res.response.data.Errors[0].Message;
          }
          this.$vs.notify({
            color: 'danger',
            title: 'Hata!',
            text: errorMessage
          });
        }
      }).catch((error) => {
        let errorMessage = 'Durum güncellenemedi';
        if (error.response && error.response.data && error.response.data.Errors && error.response.data.Errors.length > 0 && error.response.data.Errors[0].Message) {
          errorMessage = error.response.data.Errors[0].Message;
        }
        this.$vs.notify({
          color: 'danger',
          title: 'Hata!',
          text: errorMessage
        });
      });
    },
    initValues() {
      this.comment = '';
    },

    getFileUrl(filePath) {
      return this.$baseUrl + '/' + filePath;
    },

    getFileName(filePath) {
      if (!filePath) return '';
      // Extract just the filename from the full path
      const parts = filePath.split('/');
      return parts[parts.length - 1];
    },

    downloadFile(filePath) {
      if (!filePath) return;

      const baseUrl = process.env.VUE_APP_ROOT_API || '';
      const fullUrl = `${baseUrl}/${filePath}`;

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = fullUrl;
      link.setAttribute('download', this.getFileName(filePath));
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);

      // Trigger download and clean up
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style>
/* ... (mevcut stiller korundu) ... */

.status-log-item {
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 0;
}

.status-log-item:last-child {
  border-bottom: none;
}

.log-text {
  font-size: 14px;
  color: #333;
}

.log-user {
  font-size: 12px;
  color: #666;
}

.log-date {
  font-size: 12px;
  color: #999;
}
</style>
<style scoped>
.content-wrapper {
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

.content-wrapper {
  word-wrap: break-word;
}

.control-container {
  display: flex;
  align-items: center;
}

.status-select {
  margin-right: 12px;
}

/* Files section styles */
.files-container {
  margin-top: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.file-icon {
  margin-right: 10px;
  color: #5c6bc0;
}

.file-details {
  flex: 1;
}

.file-link {
  color: #5c6bc0;
  text-decoration: none;
  font-weight: 500;
}

.file-link:hover {
  text-decoration: underline;
}

.file-actions {
  margin-left: 10px;
}

/* Responsive layout for mobile screens */
@media screen and (max-width: 768px) {
  .control-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .status-select {
    margin-right: 0;
    margin-bottom: 12px;
    width: 100%;
  }

.history-button {
  width: 100%;

  ::v-deep .vs-button--text {
    color: #fff !important;
  }
}

.fixed-input {
  ::v-deep .vs-button-gradient .vs-button--text {
    color: #fff !important;
  }
}
}

.comment-files {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  padding: 10px;
  margin-top: 8px;
}

.files-heading {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #555;
  display: flex;
  align-items: center;
}

.files-list-small {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.file-item-small {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 8px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  border-left: 3px solid var(--primary);
  transition: all 0.2s ease;

  &:hover {
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .file-name {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.9rem;
  }

  .file-info {
    display: flex;
    align-items: center;
  }

  .file-actions {
    display: flex;
    gap: 5px;
  }
}

@media (max-width: 576px) {
  .file-item-small {
    flex-direction: column;
    align-items: flex-start;

    .file-actions {
      margin-top: 5px;
      align-self: flex-end;
    }
  }
}

.hidden {
  display: none;
}

.file-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.comment-actions {
  display: flex;
  align-items: center;
}
</style>
